import { Label, PrimaryButton } from "@fluentui/react";
import { IPlantillaCrearCheckList } from "../../../Interfaces/ListaVerificacion/Plantilla/IPlantillaListaverficacion";
import { IPropiedadesPorGrupo } from "../../../Interfaces/ListaVerificacion/PropiedadesVerificacion/IPropiedadesVerificacion";
import { PlantillaPreViewGrupo } from "./PlantillaPreViewGrupo";
import { IPostCrearPlantillaVerificacion } from "../../../Interfaces/IPlantillaVerificacion";
import { useCrearPlantillaVerificacion } from "../../../hooks/CheckList/useCrearPlantillaVerificacion";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";

interface IAuxPlantilla {
  datos: IPlantillaCrearCheckList;
  dataGrupos: IPropiedadesPorGrupo[];
  postCrearCheckList: IPostCrearPlantillaVerificacion;
  onDismissPanel: () => void;
}

export const PlantillaCrearCheckList = (props: IAuxPlantilla) => {
  const { postCrearPlantillaVericacion, response, loading } =
    useCrearPlantillaVerificacion(props.onDismissPanel);

  return (
    <>
      <MensajeBar response={response} ocultar={() => {}} />
      {loading == true ? (
        <IdicadorProgress isSend={loading} subText="Espere un momento..." />
      ) : (
        <>
          {" "}
          <div className="ms-Grid" dir="ltr">
            <div
              className="ms-Grid-row"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "end",
              }}
            >
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4">
                <Label>Nombre Plantilla:</Label>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8">
                <Label>{props?.datos.nombrePlantilla?.toUpperCase()}</Label>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3">
                <Label> Modelo Equipo:</Label>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg9">
                <Label>{props?.datos.modeloEquipo}</Label>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12 ms-md6 ms-lg12"
                style={{
                  height: "870px",
                  paddingTop: "20px",
                  overflow: "scroll",
                }}
              >
                {props.dataGrupos?.map((item, i) => (
                  <PlantillaPreViewGrupo data={item} indice={i} />
                ))}
              </div>
            </div>
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12 ms-md6 ms-lg12"
                style={{ paddingTop: "15px" }}
              >
                <PrimaryButton
                  text="Registrar CheckList"
                  onClick={() => {
                    postCrearPlantillaVericacion(props.postCrearCheckList);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
